import { DAILY_CHECK_IN_ENABLED } from '@/config/credit-economics';

export const DAILY_CHECK_IN_OPEN_EVENT = 'grok:daily-check-in-open';

export type DailyCheckInEntrySource =
  | 'credit_badge'
  | 'free_credits'
  | 'pricing'
  | 'video_credit_login'
  | 'video_credit_required';

export interface DailyCheckInOpenDetail {
  callbackUrl?: string;
  source: DailyCheckInEntrySource;
}

export function openDailyCheckInDialog(detail: DailyCheckInOpenDetail) {
  if (!DAILY_CHECK_IN_ENABLED) return;
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<DailyCheckInOpenDetail>(DAILY_CHECK_IN_OPEN_EVENT, {
      detail,
    })
  );
}

export function withDailyCheckInIntent(callbackUrl: string) {
  if (typeof window === 'undefined') return callbackUrl;
  const url = new URL(callbackUrl, window.location.origin);
  if (url.origin !== window.location.origin) return callbackUrl;
  url.searchParams.set('checkIn', '1');
  return `${url.pathname}${url.search}${url.hash}`;
}
